/**
 * File: /home/cordova03/projects/educore_3.5/src/app/report_cards/approve_reports/controllers/approveReportsController.js
 * Project: /home/cordova03/projects/educore_3.5
 * Created Date: Monday, December 10th 2018, 12:11:19 pm
 * Author: Naveen Nazimudeen N
 * -----
 * Last Modified: Mon Dec 10 2018
 * Modified By: Naveen Nazimudeen N
 * -----
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */

class ApproveReportsController {
    // @ngInject
    constructor($scope, $rootScope, authService, localStorageService, $state,prevReportService) {
        let self = this
        let school_id = localStorageService.get('school_id')
        let user_id = localStorageService.get('user_id')
        let activeAcd = self.scData = localStorageService.get('activeAcdYear')
        var rcApproveYear = localStorageService.get('rcApproveYear')
        const _SENT_APPROVAL = 'sent_for_approval'
        const _SENT_APPROVAL_OBJ = {
            _id:"sent_for_approval",
            name:"Not Approved"
        }
        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            $rootScope.title = "Approve Reports"

            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
            let stored_data = prevReportService.getSelectedCriterias()
            let isFromStore = false
            getSchool_acds(function (callBackData) {
                console.log(callBackData)
                $scope.year_array = findOneObject(callBackData, "Acadmic Year").array
                console.log($scope.year_array)
                loadFilters(activeAcd, function(data = {}){
                    if (stored_data) {
                        setFilterData(data, false)
                        initPaginate()
                        setModelFromStore(stored_data)
                        $scope.search(true)
                    } else {
                        console.log("no saved data")
                        clearModels()
                        $scope.model_statuses = [_SENT_APPROVAL]
                        setFilterData(data, true)
                        
                        
                    }
                })
                
            })
            
            
            console.log(stored_data)
            pushLog();
        }
        $scope.loading = true
        function _breakReference(data) {
            let keys = Object.keys(data)
            let obj = {}
            for (let k = 0; k < keys.length; k++) {
                obj[keys[k]] = data[keys[k]]
            }
            return obj
        }
        let myUserId = user_id
        $scope.year_array = []
        $scope._selected_year = activeAcd
        
        function initPaginate() {
            $scope.skip = 0
            $scope.morePage = true
            self.total_count = 0
        }
        
        function findOneObject(array, labelStr, isForCsv) {
            if (isForCsv) {
                return _.find(array, function (one) {
                    return one._id == labelStr
                })
            }
            return _.find(array, function (one) {
                return one.label == labelStr
            })
        }
        $scope.session_array = []
        $scope.curriculum_array = []
        $scope.class_array = []
        $scope.batch_array = []
        $scope.subject_array = []
        $scope.report_array = []
        $scope.status_array = []
        $scope.list = []
        self.reportCardListArray = []
        function getSchool_acds(callBack) {
            let obj = {
                user_id: myUserId,
                school_id: school_id,
                academic_year: activeAcd,
            }
            authService.callAPI("/v0/afl/get/school_acds", "POST", obj, function (response) {
                if (response.result && response.result.data && response.result.data.details) {
                    callBack(response.result.data.details)
                } else {
                    toastr.error("Server Interrupted .")
                    callBack(null)
                }
            })
        }
        
        function loadFilters(selectedYear, _cb){
            let obj = {
                user_id: myUserId,
                school_id: school_id,
                academic_year: selectedYear,
            }
            authService.callAPI("/v0/getApproverFilters", "POST", obj, function (response) {
                if (response.result && response.result.data && response.result.data.details) {
                    _cb(response.result.data.details)
                } else {
                    toastr.error("Server Interrupted .")
                    _cb(null)
                }
            })
        }
        function setFilterData(data = {}, isInit = true){
            let items = data.response
            $scope.session_array = items.sessions
            $scope.curriculum_array = items.curriculums
            $scope.class_array = items.classes
            $scope.batch_array = items.batches
            $scope.subject_array = items.subjects
            $scope.report_array = items.reports
            $scope.status_array = items.statuses
            if(!$scope.status_array.length || !$scope.status_array.find(status=>status._id==_SENT_APPROVAL)){
                $scope.status_array.push(_SENT_APPROVAL_OBJ)
            }
            if(isInit){
                $scope.model_statuses = [_SENT_APPROVAL]
                $scope.search(isInit)
            }
            
        }
        
        $scope.clearAllFilters = () => {
            $scope.loading = true
            $scope.model_sessions = null
            $scope.model_curriculums = null
            $scope.model_classes = null
            $scope.model_batches = null
            $scope.model_subjects = null
            $scope.model_reports = null
            $scope.model_statuses = []
            $scope.search(true)
        }
        function setModelFromStore(stored_data) {
            let obj = {
                school_id: school_id,
                academic_year: $scope._selected_year,
            };
            if (stored_data.session_ids && stored_data.session_ids.length) {
                $scope.model_sessions = stored_data.session_ids
            }
            if (stored_data.curriculum_ids && stored_data.curriculum_ids.length) {
                $scope.model_curriculums = stored_data.curriculum_ids
            }
            if (stored_data.class_ids && stored_data.class_ids.length) {
                $scope.model_classes = stored_data.class_ids
            }
            if (stored_data.batch_ids && stored_data.batch_ids.length) {
                $scope.model_batches = stored_data.batch_ids
            }
            if (stored_data.subject_ids && stored_data.subject_ids.length) {
                $scope.model_subjects = stored_data.subject_ids
            }
            if (stored_data.report_console_ids && stored_data.report_console_ids.length) {
                $scope.model_reports = stored_data.report_console_ids
            }
            if (stored_data.statuses && stored_data.statuses.length) {
                $scope.model_statuses = stored_data.statuses
            }
            return obj
        }
        $scope.search = (isOninit = true) => {
            let args = getSelectedModels()
            if(isOninit){
                initPaginate()
                self.reportCardListArray = []
                $scope.skip = 0
            }
            args.skip = $scope.skip
            args.morePage = $scope.morePage
            args.user_id = myUserId
            $scope.loading = true
            authService.callAPI("/v0/approverList", "POST", args, function (response) {
                if(response && response.result && 
                    response.result.data && response.result.data.details){
                    _pushToList(response.result.data.details.response)
                    $scope.skip = response.result.data.details.skip
                    $scope.morePage = response.result.data.details.morePage
                    if(response.result.data.details.total_count){
                        $scope.total_count = response.result.data.details.total_count
                        self.total_count = response.result.data.details.total_count
                    }
                }
                $scope.loading = false
                console.log(response, $scope.skip)
                prevReportService.setSelectedCriterias(null)
                $scope.$apply()
            })
        }
        function clearModels(){
            $scope.model_sessions = null
            $scope.model_curriculums = null
            $scope.model_classes = null
            $scope.model_batches = null
            $scope.model_subjects = null
            $scope.model_reports = null
            $scope.model_statuses = [_SENT_APPROVAL]
        }
        function getSelectedModels() {
            let obj = {
                school_id: school_id,
                academic_year: $scope._selected_year,
            };
            if ($scope.model_sessions && $scope.model_sessions.length) {
                obj.session_ids = $scope.model_sessions
            }
            if ($scope.model_curriculums && $scope.model_curriculums.length) {
                obj.curriculum_ids = $scope.model_curriculums
            }
            if ($scope.model_classes && $scope.model_classes.length) {
                obj.class_ids = $scope.model_classes
            }
            if ($scope.model_batches && $scope.model_batches.length) {
                obj.batch_ids = $scope.model_batches
            }
            if ($scope.model_subjects && $scope.model_subjects.length) {
                obj.subject_ids = $scope.model_subjects
            }
            if ($scope.model_reports && $scope.model_reports.length) {
                obj.report_console_ids = $scope.model_reports
            }
            if ($scope.model_statuses && $scope.model_statuses.length) {
                obj.statuses = $scope.model_statuses
            }
            if ($scope._selected_year && $scope._selected_year.length) {
                obj._selected_year = $scope._selected_year
            }
            return obj
        }
        function _pushToList(array = []) {
            for (let index = 0; index < array.length; index++) {
                try {
                    if (!self.reportCardListArray) {
                        self.reportCardListArray.list = []
                    }
                    let element = array[index];
                    if (element.report_card_header.academic_year != activeAcd) {
                        element['is_active'] = false
                    } else {
                        element['is_active'] = true
                    }
                    self.reportCardListArray.push(element)
                } catch (er) {
                    console.log(er)
                }
            }
        }
        
        $scope.loadMore = () => {
            $scope.search(false)
        }
        authService.callAPI("/v0/school/details/" + school_id, "GET", {}, function (response) {
            try {
                self.scData = response.result.data.details[0].academic_year
                let acdYear = _.find(self.scData, function (oneY) {
                    return oneY.status == 'active'
                })
                if (acdYear) {
                    if (rcApproveYear) {
                        self.selected_year = rcApproveYear
                    } else {
                        self.selected_year = acdYear.year
                    }
                  // loadData(self.selected_year)
                    // $scope.search(true)
                }
                $scope.$apply()
            } catch (ex) {
                console.log(ex);
            }
        })

        function loadData(selected_year) {
            let postValues = {
                args: {
                    selected_year: selected_year,
                    myUserId: user_id
                }
            }
            authService.callAPI("/v0/reportcards/approver/reports", "POST", postValues, function (response) {
                try {
                    let reportCardListArray = response.result.data.details.response
                    _.each(reportCardListArray, function (oneRcData) {
                        if (oneRcData.report_card_header.academic_year != activeAcd) {
                            oneRcData['is_active'] = false
                        } else {
                            oneRcData['is_active'] = true
                        }
                    })
                    self.reportCardListArray = reportCardListArray
                    $scope.loading = false
                    $scope.$apply()
                } catch (ex) {
                    console.log(ex);
                }
            })
        }

        self.listRcWithSelectedYear = (selected_year) => {
            if (selected_year) {
                localStorageService.set({
                    rcApproveYear: selected_year
                })
            }
            self.selected_year = selected_year
            $scope.loading = true
            console.log(selected_year)
            loadFilters(selected_year, function(data){
                console.log('year changed')
                setFilterData(data, true)
            })
            // loadData(self.selected_year)
        }

        self.viewTemplate = (card={}) => {
            let obj = getSelectedModels()
            prevReportService.setSelectedCriterias(obj)
            $state.go('viewGeneratedReportData', {
                "dataId": card._id,
                selected_year: self.selected_year,
                is_edit : false
            })
        }

        function pushLog(){  
            authService.callRabbitMQAPI("/v0/rabbitmqpush/"+user_id+"/"+school_id+"/reportCardApproval_Listing", "GET", {},function (response) {
                  // console.log(response)
            });
        }


        this.$onDestroy = () => {

        }
    }
}

export default ApproveReportsController;




// WEBPACK FOOTER //
// ./src/app/report_cards/approve_reports/controllers/approveReportsController.js